import { notification } from 'antd'
import ApiEndPoints from 'utils'
import apiClient from '../index'

export const addNewProject = async (projectData) => {
  try {
    return await apiClient.post('projectInfo', projectData)
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
  return null
}
export const fetchNewProjectId = async () => {
  try {
    return await apiClient.get('projectInfo/getNewProjectId')
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
  return null
}

export const getAllProjectInfoList = async (params) => {
  const { skip, limit, searchedProject, status } = params
  try {
    return await apiClient.get(`projectInfo`, {
      params: {
        skip,
        limit,
        searchedProject,
        status,
      },
    })
  } catch (error) {
    if (error) {
      notification.error({
        message: error?.message,
      })
    }
  }
  return null
}

export const updateProjectInfo = async (data) => {
  try {
    return await apiClient.patch(`projectInfo`, data)
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
  return null
}

export const assignEmployee = async (data) => {
  try {
    return await apiClient.post('projectInfo/assign', data)
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
  return null
}

export const getPoForSelectedEmployee = async (userId) => {
  try {
    const res = await apiClient.get(`${ApiEndPoints.EMPLOYEE_PO}/${userId}`)
    // const empPos = res?.data?.data?.po?.map((data) => data?.userId)
    const empPos = res?.data?.data?.poArray
    return empPos
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
  return null
}
export const getTeamForEmp = async (userId) => {
  try {
    const res = await apiClient.get(`${ApiEndPoints.EMPLOYEE_TEAM}/${userId}`)
    return res
    // const empTeam = res?.data?.data?.teamArray
    // return empTeam
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
  return null
}

export const removeDeveloper = async (id, date) => {
  try {
    return await apiClient.patch(`${ApiEndPoints.REMOVE_ASSIGN_DEVELOPER}/${id}`, date)
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
  return null
}

export const fetchSingleProjectInfo = async (id) => {
  try {
    return await apiClient.get(`${ApiEndPoints.FETCH_SINGLE_PROJECT_INFO}/${id}`)
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
  return null
}
export const fetchProjectTeamMembers = async (userId) => {
  try {
    return await apiClient.get(`${ApiEndPoints.FETCH_TEAM_MEMBERS}/${userId}`)
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
  return null
}

export const updateAssignDeveloper = async (updateData, id) => {
  try {
    return await apiClient.patch(`${ApiEndPoints.UPDATE_ASSIGN_DEVELOPER}/${id}`, updateData)
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
  return null
}

export const getProjectDocumentList = async (id) => {
  try {
    return await apiClient.get(`${ApiEndPoints.FETCH_PROJECT_DOCUMENT}/${id}`)
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
  return null
}

export const uploadProjectDocument = (data) =>
  apiClient.post(`${ApiEndPoints.UPLOAD_PROJECT_DOCUMENT}`, data)

export const getUploadedDocumentUrl = async (id) => {
  try {
    return await apiClient.get(`${ApiEndPoints.FETCH_DOCUMENT_URL}/${id}`)
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
  return null
}

export const updateProjectDocument = async (updateData) => {
  try {
    return await apiClient.patch(`${ApiEndPoints.UPDATE_PROJECT_DOCUMENT}`, updateData)
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
  return null
}
